import { useContext, useEffect, useState } from 'react';

import {
	Button,
	Card,
	Flex,
	Input,
	List,
	Pagination,
	Space,
	Spin,
	Typography,
} from 'antd';
import Meta from 'antd/es/card/Meta';
import { Link, NavLink, useNavigate } from 'react-router-dom';

import { SubscriptionContext } from '@/App';
import { useGetCategories } from '@/api/monitor_collections';
import { SUBSCRIPTIONS_TYPES_ENUM } from '@/const';
import { useDebounce } from '@/hooks';
import { formatSecondsToTime } from '@/lib/helpers/formatSecondsToTime';
import getReadableCron from '@/lib/helpers/getReadableCron';
import hasSubscriptionType from '@/lib/helpers/hasSubscriptionType';
import { PageContext } from '@/providers/PageContextProvider';
import { IPagination, TSortBy, TSortOrder } from '@/ts';

import styles from './style.module.css';

export default function SemanticSearch() {
	const { setPageTitle, setIsCreditsCounterVisible } = useContext(PageContext);
	const navigate = useNavigate();
	const { subscriptions, subscriptionLoading } =
		useContext(SubscriptionContext);

	useEffect(() => {
		setPageTitle('Semantic search');
		setIsCreditsCounterVisible(false);

		return () => {
			setPageTitle('');
			setIsCreditsCounterVisible(true);
		};
	}, []);

	useEffect(() => {
		if (!subscriptionLoading && subscriptions && subscriptions?.length > 0) {
			if (
				!hasSubscriptionType(subscriptions, SUBSCRIPTIONS_TYPES_ENUM.datalake)
			) {
				navigate('/app/dashboard/product-main-menu');
			}
		} else if (
			!subscriptionLoading &&
			subscriptions &&
			subscriptions?.length === 0
		) {
			navigate('/app/dashboard/product-main-menu');
		}
	}, [subscriptions, subscriptionLoading]);

	return (
		<div>
			<h2>Semantic search</h2>

			<p>Coming soon...</p>
		</div>
	);
}
